// Filename: bumble_cfg.js
// Timestamp: 2018.12.09-18:14:35 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gnnodexui from '@bumblehead/gani/src/gnnodexui.js'
import gnnodexdata from '@bumblehead/gani/src/gnnodexdata.js'
import gnnodexdatals from '@bumblehead/gani/src/gnnodexdatals.js'
import uih1 from '@bumblehead/gani/src/basic/uih1.js'
import uilink from '@bumblehead/gani/src/basic/uilink.js'
import uilabel from '@bumblehead/gani/src/basic/uilabel.js'
import uistatic from '@bumblehead/gani/src/basic/uistatic.js'
import uiroot from '@bumblehead/gani/src/basic/uiroot.js'
import uiimg from '@bumblehead/gani/src/basic/uiimg.js'
import uiobjls from '@bumblehead/gani/src/basic/uiobjls.js'
import uils from '@bumblehead/gani/src/basic/uils.js'
import uidropdown from '@bumblehead/gani/src/basic/uidropdown.js'
import uispread from '@bumblehead/gani/src/basic/uispread.js'
import uilsparts from '@bumblehead/gani/src/basic/uilsparts.js'

import datascene from './datascene.js'

import uipageselect from './uipageselect.js'
import uiarticle from './uiarticle.js'
import uiarticleTileOneLine from './uiarticleTileOneLine.js'
import uiarticleTileSuggest from './uiarticleTileSuggest.js'
import uiarticleTilePreview from './uiarticleTilePreview.js'

import uiarticlesub from './uiarticlesub.js'
import uiarticleprev from './uiarticleprev.js'
import uisitemap from './uisitemap.js'
import uisitemaptags from './uisitemaptags.js'
import uicanvasportal from './uicanvasportal.js'
import uicanvasportalbg from './uicanvasportalbg.js'

import uicanvasstageseq from './uicanvasstageseq.js'
import uicanvasstageseqaction from './uicanvasstageseqaction.js'
import uicanvasstageseqactionshape from './uicanvasstageseqactionshape.js'

import * as querieslogic from '@bumblehead/gaql/src/queries/logic.js'
import * as queriestime from '@bumblehead/gaql/src/queries/time.js'
import * as queriescore from '@bumblehead/gaql/src/queries/core.js'
import * as queriesaggregate from '@bumblehead/gaql/src/queries/aggregate.js'
import * as queriestransform from '@bumblehead/gaql/src/queries/transform.js'
import * as queriesclient from '@bumblehead/gani/src/queries/client.js'
import * as queriesstring from '@bumblehead/gaql/src/queries/string.js'
import * as queriestodo from './bumble_queries.js'

import gaqlrun from '@bumblehead/gaql/src/gaqlrun.js'

export default {
  // lang: 'eng-US',
  // locale: 'US',
  // version: process.env.npm_package_version,
  // specpath: './spec/view/',
  gaqlrun,
  gaqlqueries: Object.assign({},
    queriescore,
    queriestime,
    querieslogic,
    queriesaggregate,
    queriestransform,
    queriesclient,
    queriesstring,
    queriestodo),

  nodes: [
    gnnodexui,
    gnnodexdata,
    gnnodexdatals,

    uih1,
    uilink,
    uilabel,
    uistatic,
    uiroot,
    uiimg,
    uiobjls,
    uils,
    uidropdown,
    uispread,
    uilsparts,

    datascene,

    uipageselect,
    uiarticlesub,
    uiarticleprev,
    uisitemap,
    uisitemaptags,
    uiarticle,
    uiarticleTileOneLine,
    uiarticleTileSuggest,
    uiarticleTilePreview,

    uicanvasportal,
    uicanvasportalbg,

    uicanvasstageseq,
    uicanvasstageseqaction,
    uicanvasstageseqactionshape
  ]
}
